/* PREASENS — GEOLOCALISATION AUTOMATIQUE PAR MARCHE (v2, corrigée)
   1re visite de la session : Australie -> /en-au/ (anglais + AUD), reste du monde -> / (français + EUR).
   Corrections vs v1 :
   - sessionStorage au lieu de localStorage : un visiteur mal classé n'est plus coincé pour toujours ;
   - ne s'exécute jamais si l'utilisateur a choisi manuellement un pays/langue (marqueur posé par le sélecteur) ;
   - ne s'exécute pas dans l'éditeur de thème ni sur les pages panier/checkout/compte ;
   - la partie « fix devise panier » de la v1 a été supprimée : le panier gère nativement
     la devise via les routes localisées (voir liftface-pro.js). */
(function(){
  try{
    if (window.Shopify && window.Shopify.designMode) return;
    var KEY = 'pa_geo_v2';
    if (sessionStorage.getItem(KEY)) return;
    if (localStorage.getItem('pa_geo_manual')) return; /* choix manuel = on respecte */
    var path = window.location.pathname;
    if (/^\/(cart|checkout|account|challenge|password)/.test(path.replace(/^\/en-au/, ''))) return;
    var seg  = (path.split('/')[1] || '').toLowerCase();
    var onAU = (seg === 'en-au' || seg === 'fr-au');
    fetch('/browsing_context_suggestions.json', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(d){
        try { sessionStorage.setItem(KEY, '1'); } catch(e){}
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!c) return;
        c = String(c).toUpperCase();
        var tail = window.location.search + window.location.hash;
        if (c === 'AU' && !onAU) {
          window.location.replace('/en-au' + path + tail);
        } else if (c !== 'AU' && onAU) {
          var stripped = path.substring(seg.length + 1);
          window.location.replace((stripped || '/') + tail);
        }
      })
      .catch(function(){ try { sessionStorage.setItem(KEY, '1'); } catch(e){} });
  } catch(e){}
})();

/* Marque le choix manuel de pays/langue pour ne plus jamais rediriger contre la volonté du visiteur */
(function(){
  document.addEventListener('click', function(e){
    var link = e.target && e.target.closest && e.target.closest('.disclosure__link[data-value]');
    if (link) { try { localStorage.setItem('pa_geo_manual', '1'); } catch(err){} }
  }, true);
})();
